import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { logout, selectUser, setUser } from "./authSlice";
import apiClient from "core/api/apiClient";
import { initiateSocket, disconnectSocket } from "core/socket/socket";

const SessionGuard = ({ children }) => {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const [checked, setChecked] = useState(false);
  const verifiedRef = useRef(false);

  useEffect(() => {
    const onRefreshFailed = () => {
      dispatch(logout());
    };
    window.addEventListener("auth:refresh-failed", onRefreshFailed);
    return () => window.removeEventListener("auth:refresh-failed", onRefreshFailed);
  }, [dispatch]);

  // ── Socket lifecycle: connect when authenticated, disconnect on logout ──
  useEffect(() => {
    if (user) {
      initiateSocket();
    } else {
      disconnectSocket();
    }
  }, [user]);

  useEffect(() => {
    if (verifiedRef.current) return;
    verifiedRef.current = true;

    if (!user) {
      setChecked(true);
      return;
    }

    const verify = async () => {
      try {
        const res = await apiClient.get("/users/me", { timeout: 5000 });
        if (res.data?.success && res.data?.user) {
          dispatch(setUser(res.data.user));
        } else {
          dispatch(logout());
        }
      } catch {
        dispatch(logout());
      } finally {
        setChecked(true);
      }
    };

    verify();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (!checked) return null;

  return children;
};

export default SessionGuard;
